// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23srh","badges":"styles_badges__3vR3N"};